module.exports = __webpack_public_path__ + "img/cross.84113b92.svg";